/**
 * 门户文本默认配置数据
 */
export const home = [
  {
    "width": 89,
    "height": 43,
    "content": 1234,
    "fontSize": 24,
    "fontColor": "rgba(0, 0, 0, 1)",
    "showThousandSeparator": true,
    "bgColor": "rgba(0, 92, 229, 0)"
  }
]

/**
 * 大屏文本默认配置数据
 */
export const bs = [
  {}
]

/**
 * app数字滚动默认配置数据
 */
export const appHome = [
  {
    "width": 89,
    "height": 43,
    "content": 1234,
    "fontSize": 24,
    "fontColor": "rgba(0, 0, 0, 1)",
    "showThousandSeparator": true,
    "bgColor": "rgba(0, 92, 229, 0)"
  }
]
